import { ImageFrame } from "~/common/components/image/ImageFrame";
import classNames from "classnames";
import { CardOrientation } from "~/models/card";

export const CardFrame = ({
  children,
  image,
  largeImageSize = false,
  className = "",
  hoverAnimation = true,
  orientation = "vertical",
}: {
  children: React.ReactNode;
  image?: React.ReactNode;
  largeImageSize?: boolean;
  className?: string;
  hoverAnimation?: boolean;
  orientation?: CardOrientation;
}) => {
  return (
    <div
      className={classNames(
        "tw:rounded-[20px] tw:!shadow-gray-500 tw:!shadow-lg",
        orientation === "horizontal"
          ? "tw:flex tw:flex-row tw:w-full"
          : "tw:flex tw:flex-col tw:w-full",
        hoverAnimation
          ? "tw:cursor-pointer tw:!transition tw:!duration-500 tw:!ease-in-out tw:hover:!scale-[1.03]"
          : "",
        className,
      )}
    >
      <div
        className={classNames(
          orientation === "horizontal"
            ? largeImageSize
              ? "tw:basis-1/2"
              : "tw:basis-1/4"
            : "tw:h-[190px] ",
          "tw:border-b! tw:border-b-[#cdd1e0]!",
        )}
      >
        {image && <ImageFrame orientation={orientation}>{image}</ImageFrame>}
      </div>
      <div
        className={classNames(
          "tw:pb-6 tw:bg-white tw:h-full tw:rounded-b-[20px]",
          orientation === "horizontal"
            ? largeImageSize
              ? "tw:basis-1/2"
              : "tw:basis-3/4"
            : "",
        )}
      >
        {children}
      </div>
    </div>
  );
};
